import { useRoute } from 'vue-router';

import { useClientsStore } from '../store/clients';
import { useCalculationsStore } from '../store/calculations';

export function useBreadcrumbs() {
  const clientStore = useClientsStore();
  const calculationsStore = useCalculationsStore();

  const route = useRoute();

  function getClientLabel() {
    const client = clientStore.getClientByUuid(String(route.params.clientId));

    if (!client) return 'Klient';

    return `Klient ${client.last_name}`;
  }

  function getCalculationLabel() {
    const calculation = calculationsStore.getCalculationByUuid(String(route.params.calculationId));

    if (!calculation) return 'Kalkulacja';

    return `Kalkulacja ${calculation.name}`;
  }

  function handleBreadcrumbs() {
    const breadcrumbs = (route.meta.breadcrumb as Function)(route) as {
      label: string;
      url: string;
      type?: 'client' | 'calculation';
    }[];

    return breadcrumbs.map((breadcrumb) => {
      if (breadcrumb.type === 'client') {
        return {
          ...breadcrumb,
          label: getClientLabel(),
        };
      }

      if (breadcrumb.type === 'calculation') {
        return {
          ...breadcrumb,
          label: getCalculationLabel(),
        };
      }

      return breadcrumb;
    });
  }

  return {
    handleBreadcrumbs,
  };
}
